import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "hamburger",
  "use": "hamburger-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"hamburger\"><path d=\"M32 24v2H0v-2h32zm0-9v2H0v-2h32zm0-9v2H0V6h32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol